import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import BlogPreview from './components/BlogPreview';
import TrustSection from './components/TrustSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <BlogPreview />
      <TrustSection />
      <CTASection />
      <Footer />
    </main>
  );
}